const Routes = [
  {
    path: '/admin',
    name: 'admin',
    component: () => import('@/app/admin/TheAdmin'),
    redirect: '/admin/',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        component: () => import('@/app/admin/views/Index')
      },
      {
        path: 'load-status',
        name: 'loadStatus',
        component: () => import('@/app/admin/load_status/views/Index')
      },
      {
        path: 'material-management',
        name: 'materialManagement',
        component: () => import('@/app/admin/views/MaterialManagement'),
        children: [
          {
            path: 'default',
            name: 'MaterialManagementDefault',
            component: () => import('@/app/admin/views/MaterialManagementDefault')
          },
          {
            path: 'legacy',
            name: 'materialManagementLegacy',
            component: () => import('@/app/admin/views/MaterialManagementLegacy')
          }
        ]
      },
      {
        path: 'users-management',
        name: 'usersManagement',
        component: { name: 'usersManagement', render (c) { return c('router-view') } },
        redirect: '/admin/users-management/',
        children: [
          {
            path: '',
            component: () => import('@/app/admin/user_management/views/UsersManagement')
          },
          {
            path: 'user/:id',
            name: 'UserDetail',
            component: () => import('@/app/admin/user_management/views/UserDetail'),
            props: true
          },
          {
            path: 'create',
            name: 'UserCreate',
            component: () => import('@/app/admin/user_management/views/UserDetail'),
            props: { id: 'new' }
          }
        ]
      },
      {
        path: 'categories-management',
        name: 'categoriesManagement',
        component: () => import('@/app/admin/views/CategoryManagement')
      },
      {
        path: 'b2b-credential-update',
        name: 'B2BCredentialUpdate',
        component: () => import('@/app/admin/views/B2BPasswords')

      },
      {
        path: 'price-master',
        name: 'PriceMaster',
        component: () => import('@/app/admin/views/PriceMaster'),
        props: true
      },
      {
        path: 'client-dynamic-master',
        name: 'clientDynamicMaster',
        component: () => import('@/app/admin/client_dynamic_master/views/Index'),
        meta: {
          requiresAuth: true,
          requiresAdmin: true
        }
      },
      {
        path: 'global-custom-metric-name',
        name: 'globalCustomMetricName',
        component: () => import('@/app/admin/global_custom_metric_name/views/Index'),
        meta: {
          requiresAuth: true,
          requiresAdmin: true
        }
      },
      {
        path: 'api-bridge',
        name: 'apiBridge',
        component: () => import('@/app/admin/api_bridge/views/Index'),
        meta: {
          requiresAuth: true,
          requiresAdmin: true
        }
      }
    ]
  }
]

export default Routes



// WEBPACK FOOTER //
// ./src/app/admin/Routes.js